import { Inject, Injectable } from '@angular/core';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { Envelope } from '../../interfaces/envelopes/envelope';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { Observable } from 'rxjs';
import { PatchDocument } from '../../interfaces/patch-document';
import { Document } from '../../interfaces/documents/document';
import { eDocumentType } from '../../enums';
import { Order } from '../../interfaces/orders/order';

@Injectable({
  providedIn: 'root'
})
export class EnvelopeRepositoryService extends PaginatedRepository<Envelope> {
  public selectedEnvelope: Envelope | undefined;
  
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(http, messageService);
    this._baseLink = `${config.rootUrl}/Envelopes`;
  }

  public patchEnvelope(envelopeId: string, patchDocument: PatchDocument[]): Observable<void> {
    return this.http.patch<void>(`${this._baseLink}/${envelopeId}`, patchDocument);
  }

  public next(envelopeId: string): Observable<void> {
    return this.http.post<void>(`${this._baseLink}/${envelopeId}/state/next`, { });
  }

  public previous(envelopeId: string): Observable<void> {
    return this.http.post<void>(`${this._baseLink}/${envelopeId}/state/previous`, { });
  }

  public removeOrderFromEnvelope(envelopeId: string, orderId: string) {
    return this.http.delete<void>(`${this._baseLink}/${envelopeId}/Orders/${orderId}`);
  }
  
  public getOrderEnvelopes(orderID: string) {
    return this.http.get<Envelope[]>(`${this.config.rootUrl}/Orders/${orderID}/Envelopes`);
  }
  
  public getEnvelope(envelopeID: string) {
    return this.http.get<Envelope>(`${this.config.rootUrl}/Envelopes/${envelopeID}`);
  }
  
  public getOrders(envelopeID: string) {
    return this.http.get<Order[]>(`${this.config.rootUrl}/Envelopes/${envelopeID}/Orders`);
  }

  public getEnvelopeDocument(envelopeID: string, document: Document) {
    let headers = new HttpHeaders();
    
    if(document.documentTypeID === eDocumentType.pdf) {
      headers = headers.append('accept', 'application/pdf');
    }

    return this.http.get(`${this.config.rootUrl}/Envelopes/${envelopeID}/Document`, { headers: headers, responseType: 'blob' });
  }
}
